module.exports = __webpack_public_path__ + "static/vacationApply.aeda18b7.svg";